import React from 'react';
import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';
import { View } from 'react-native';

const Homepage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Homepage" */ '../containers/Homepage'),
  loading: DefaultLoadingScreen,
});

class HomepageScreen extends React.Component {
  static navigationOptions = () => ({
    headerLeft: <View />,
  });

  render() {
    return <Homepage {...this.props} />;
  }
}

export default HomepageScreen;
